import { createSlice } from '@reduxjs/toolkit';

// ----------------------------------------------------------------------

const initialState = {
  isLoading: false
};

const slice = createSlice({
  name: 'loading',
  initialState,
  reducers: {
    openLoading: (state) => {
      state.isLoading = true;
    },
    closeLoading: (state) => {
      state.isLoading = false;
    }
  }
});

// Reducer
export default slice.reducer;

// Actions
export const { openLoading, closeLoading } = slice.actions;

// ----------------------------------------------------------------------

export function getLoading(msg) {
  return async (dispatch) => {
    try {
      dispatch(openLoading());
    } catch (error) {
      console.log('error', error);
    }
  };
}

// ----------------------------------------------------------------------

export function getCloseLoading() {
  return async (dispatch) => {
    try {
      dispatch(closeLoading());
    } catch (error) {
      console.log('error', error);
    }
  };
}
